import { GET_RENDER_PREVIEW, OP_GET_RENDER_PREVIEW_API, UPDATE_PRODUCT_RENDER_JSON } from '../../config/constant/apiConstant';
import { MODEL_TYPES } from '../../constants/constants';
import { updateRenderAPI } from '../../helpers/apiHelper';
import { myRenderPreviewActions } from '../../redux/slicers/render_preview/myRenderPreviewSlice';
import { createGetListAction, createUpdateApiAction, createDeleteApiAction } from '../apiGenerator';

export const getRenderPreviewListApi = createGetListAction({
  endpoint: OP_GET_RENDER_PREVIEW_API, // GET_RENDER_PREVIEW
  actions: myRenderPreviewActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.PROJECTRENDER
});

export const updateRenderPreviewApi = createUpdateApiAction({
  actions: myRenderPreviewActions,
  endpointUrl: GET_RENDER_PREVIEW,
});

export const deleteRenderPreviewAPI = createDeleteApiAction({
  actions: myRenderPreviewActions,
  endpointUrl: GET_RENDER_PREVIEW,
  successMessage: 'Deleted',
});

export const updateProductRenderJsonDataAPI = async ({ id, payload }) => {
  const response = await updateRenderAPI({ id, payload });
  return response
};
